<template>
    <div class='dropdown-item' @click='handleSelectVoiceType'>
        <div
            class='content'
        >
            <button-circle
                :size='21'
                :active='status'
                :disabled='sampleLoading'
                :progress='progressAudio'
                :color="''"
                @handleClick='handleAction'
            >
                <vector-icon v-if='!status' icon='play-icon' :size='[12, 11]' />
                <vector-icon v-else icon='pause-icon' :size='[12, 11]' />
            </button-circle>
            <span class='description'>{{ voice.name }}</span>
            <template v-if='isCustomVoices'>
                <a
                    @click.prevent='handleRemove'
                >
                    <fa-icon icon='trash' />
                </a>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        voice: { type: Object, required: true },
        isCustomVoices: { type: Boolean, default: false },
        type: { type: String, required: true },
        onLoadSampleUrl: {type: Function, required: true}
    },

    emits: ['selectedVoice', 'removeVoice'],

    data: () => ({
        status: false,
        isActivePlayButton: false,
        progressAudio: 0,
        sampleLoading: false,
        sampleUrl: null,
    }),

    methods: {
        async init() {
            this.audio = new Audio();

            await this.$delay();

            this.initEvents();
        },

        initEvents() {
            if (this.audio) {
                this.audio.addEventListener('loadstart', this.handleSampleLoadStart);
                this.audio.addEventListener('canplaythrough', this.handleSampleLoadStop);
                this.audio.addEventListener('ended', this.handleEventEnded);
                this.audio.addEventListener('timeupdate', this.handleEventTimeUpdate);
            }
        },

        async initAudio() {
            if (this.audio && this.voice) {
                if (!this.sampleUrl) {
                    try {
                        this.handleSampleLoadStart();
                        this.sampleUrl = await this.onLoadSampleUrl(this.voice.id, this.type);
                    } finally {
                        this.handleSampleLoadStop();
                    }
                }
                this.audio.id = '';
                this.audio.pause();
                this.audio.src = this.sampleUrl;
            }
        },

        removeEvents() {
            if (this.audio) {
                this.audio.removeEventListener('loadstart', this.handleSampleLoadStart);
                this.audio.removeEventListener('canplaythrough', this.handleSampleLoadStop);
                this.audio.removeEventListener('ended', this.handleEventEnded);
                this.audio.removeEventListener('timeupdate', this.handleEventTimeUpdate);
            }
        },

        handleEventTimeUpdate(e) {
            this.progressAudio = Math.abs((e.target.currentTime / e.target.duration) * 100);
        },

        handleEventEnded() {
            this.audio.currentTime = 0;
            this.audio.pause();
            this.status = !this.status;
        },

        handleSampleLoadStart() {
            this.sampleLoading = true;
        },

        handleSampleLoadStop() {
            this.sampleLoading = false;
        },

        async handleAction() {
            this.isActivePlayButton = true;
            await this.initAudio();

            this.status = !this.status;

            if (this.status) {
                this.audio.play();
            } else {
                this.audio.currentTime = 0;
                this.audio.pause();
            }

            await this.$delay(5);
            this.isActivePlayButton = false;
        },
        handleSelectVoiceType() {
            if (this.isActivePlayButton) return;
            const currentVoice = {
                id: this.voice.id,
                name: this.voice.name,
                preview_url: this.voice.preview_url,
                type: this.type
            };
            this.$emit('selectedVoice', currentVoice);
        },

        handleRemove(e) {
            e.stopPropagation();

            this.$emit('removeVoice', this.voice);
        }
    },

    mounted() {
        this.init();
    },

    unmounted() {
        this.removeEvents();
    }
};

</script>
